import { combineReducers } from '@reduxjs/toolkit';
import { createAchPushSlice } from './achPushes/createAchPushSlice';
import { updateAchPushSlice } from './achPushes/updateAchPushSlice';
import { sendAchPushSlice } from './achPushes/sendAchPushSlice';
import { deleteAchPushSlice } from './achPushes/deleteAchPushSlice';
import { createInternalTransferSlice } from './internalTransfers/createInternalTransferSlice';
import { updateInternalTransferSlice } from './internalTransfers/updateInternalTransferSlice';
import { sendInternalTransferSlice } from './internalTransfers/sendInternalTransferSlice';
import {
  getBankAccountForCategoryAndStateSlice,
  getDestinationAccountsForStateSlice,
} from './internalTransfers/getInternalTransferSlice';
import { createManualCheckSlice } from './manualCheckDisbursements/createManualCheckSlice';
import { updateManualCheckSlice } from './manualCheckDisbursements/updateManualCheckSlice';
import { deleteManualCheckSlice } from './manualCheckDisbursements/deleteManualCheckSlice';
import { createWireDisbursementSlice } from './wireDisbursements/postWireDisbursementSlice';
import { updateWireDisbursementSlice } from './wireDisbursements/updateWireDisbursementSlice';
import { sendWirePushSlice } from './wireDisbursements/sendWirePushSlice';
import { deleteWireDisbursementSlice } from './wireDisbursements/deleteWireDisbursementSlice';
import { deleteInternalTransferSlice } from './internalTransfers/deleteInternalTransferSlice';

export const disbursementsReducer = combineReducers({
  // ACH Disbursements
  createAchPush: createAchPushSlice.reducer,
  updateAchPush: updateAchPushSlice.reducer,
  sendAchPush: sendAchPushSlice.reducer,
  deleteAchPush: deleteAchPushSlice.reducer,

  // Internal Transfer Disbursements
  createInternalTransfer: createInternalTransferSlice.reducer,
  updateInternalTransfer: updateInternalTransferSlice.reducer,
  sendInternalTransfer: sendInternalTransferSlice.reducer,
  deleteInternalTransfer: deleteInternalTransferSlice.reducer,
  //
  getBankAccountForCategoryAndState: getBankAccountForCategoryAndStateSlice.reducer,
  getDestinationAccountsForState: getDestinationAccountsForStateSlice.reducer,

  // Check Disbursements
  createManualCheck: createManualCheckSlice.reducer,
  updateManualCheck: updateManualCheckSlice.reducer,
  deleteManualCheck: deleteManualCheckSlice.reducer,

  // Wire Disbursements
  createWireDisbursement: createWireDisbursementSlice.reducer,
  updateWireDisbursement: updateWireDisbursementSlice.reducer,
  sendWirePush: sendWirePushSlice.reducer,
  deleteWireDisbursement: deleteWireDisbursementSlice.reducer,
});
